export type ResourceContextConfig = {
  fabricMipmapsHighQuality: boolean;
  frustumCulling: boolean;
};

/**
 * Create resources context config.
 */
export const create = (() => {
  const ConfigDef: ResourceContextConfig = {
    fabricMipmapsHighQuality: true,
    frustumCulling: true,
  };

  return (config?: Partial<ResourceContextConfig>) => {
    config ??= {};
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
